import type { Ref } from 'vue';
import { useQuery, keepPreviousData } from '@tanstack/vue-query';
import { unref } from 'vue';
import { getApi } from './api';

export interface GetAccountShipmentsParams {
  [key: string]: unknown;
}

/**
 * Paginated list: GET `/api/v2/accounts/{account}/shipments` (gpx-engine V2 index).
 * Use `include: 'devices'` for devices; add `stops` (e.g. `devices,stops`) for stop payloads from device-api.
 */
export default (
  accountId: Ref<number> | number,
  params?: Ref<GetAccountShipmentsParams> | GetAccountShipmentsParams,
) => {
  return useQuery({
    queryKey: [
      'account-shipments',
      () => unref(accountId),
      () => unref(params),
    ],
    queryFn: () => {
      const { api, baseURL } = getApi();
      const actualAccountId = unref(accountId);
      const queryParams = unref(params);
      return api
        .get(`/api/v2/accounts/${actualAccountId}/shipments`, {
          baseURL,
          params: queryParams,
        })
        .then((res: { data: unknown }) => res.data);
    },
    placeholderData: keepPreviousData,
    enabled: !!unref(accountId),
  });
};
